import { Alert, Box, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";

import { useExternalRegisterImport } from "./externalRegisterImportProvider";
import { ImportHeaderBar } from "./ExternalRegisterImportHeader";
import { ExternalRegisterImportCrashTestButton } from "./ExternalRegisterImportDiagnostics";
import { SourceCsvStage } from "./ExternalRegisterImportSourceStage";
import { ParseResultsStage } from "./ExternalRegisterImportParseStage";
import { MappingStage } from "./ExternalRegisterImportMappingStage";
import { ReviewRowsStage } from "./ExternalRegisterImportReviewStage";
import { CommitReportStage } from "./ExternalRegisterImportReportStage";

export const ExternalRegisterImportContent = () => {
  const { t } = useTranslation();
  const {
    activeStage,
    draftIsActive,
    errorMessage,
    stageStatuses,
    cancelImport,
    setActiveStage,
    latestCommitResponse,
  } = useExternalRegisterImport();

  return (
    <Box sx={{ position: "relative", height: "100%", width: "100%", overflow: "hidden" }}>
      <Box
        sx={{
          height: "100%",
          width: "100%",
          overflow: activeStage === "review" ? "hidden" : "auto",
          px: 3,
          pt: 0,
          pb: activeStage === "review" ? 3 : 10,
        }}
      >
        <Stack
          spacing={3}
          sx={{
            width: "100%",
            height: activeStage === "review" ? "100%" : "auto",
            minHeight: 0,
          }}
        >
          <ImportHeaderBar
            draftIsActive={draftIsActive}
            activeStage={activeStage}
            stageStatuses={stageStatuses}
            onCancel={cancelImport}
            onStageChange={setActiveStage}
            resetAvailable={draftIsActive || Boolean(latestCommitResponse)}
            resetLabel={latestCommitResponse ? t("externalRegister.import.header.buttons.resetImport") : t("externalRegister.import.header.buttons.cancelImport")}
          />

          <ExternalRegisterImportCrashTestButton />
          {errorMessage && <Alert severity="warning">{errorMessage}</Alert>}

          {activeStage === "source" && <SourceCsvStage />}
          {activeStage === "parse" && <ParseResultsStage />}
          {activeStage === "mapping" && <MappingStage />}
          {activeStage === "review" && <ReviewRowsStage />}
          {activeStage === "report" && <CommitReportStage />}
        </Stack>
      </Box>
    </Box>
  );
};
